// extracted by extract-css-chunks-webpack-plugin
module.exports = {"download-links":"download-links__download-links___2O7-Y","downloadLinks":"download-links__download-links___2O7-Y","download-link":"download-links__download-link___1Md2z","downloadLink":"download-links__download-link___1Md2z"};
    if(module.hot) {
      // 1782327154575
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  